import React from 'react'

import { Link } from "react-router-dom"

import UserTab from '../elements/UserTab.jsx'
import Button from '../elements/Button.jsx'

const Main = (props) => {

    const renderButton = (button, index, isFirst = false) => {

        const buttonElement = (
            <Button
                onClick={button.onClick}
                colors={props.colors}
                active={
                    isFirst
                        ? props.activeButton
                        : props.selected === index
                }
                Style={{
                    width: '80%',
                    margin: 'auto',
                    marginTop: isFirst ? '15px' : '0px',
                    marginBottom: '10px',
                    height: '40px'
                }}
            >
                {button.name}
            </Button>
        )

        // Action-only buttons should not be wrapped in an empty Link.
        // This avoids Safari potentially interpreting a scroll gesture
        // as navigation to the current route.
        if (!button.link) {
            return (
                <div key={button.key ?? button.name ?? index}>
                    {buttonElement}
                </div>
            )
        }

        return (
            <Link
                key={button.key ?? button.link ?? button.name ?? index}
                to={button.link}
                style={{
                    height: '30px',
                    textDecoration: 'none'
                }}
            >
                {buttonElement}
            </Link>
        )
    }

    return (
        <div
            style={{
                width: '370px',

                // More reliable than height: 100vh on Safari.
                position: 'fixed',
                top: 0,
                bottom: 0,

                display: 'flex',
                flexDirection: 'column',

                borderRight: '1px solid ' + props.colors.border,
                marginLeft: '20px',

                // Prevent the fixed parent itself from becoming
                // part of Safari's scroll calculations.
                overflow: 'hidden'
            }}
        >
            <div
                className='verticalCenter'
                style={{
                    flex: '0 0 75px',
                    marginLeft: '20px',
                    marginTop: '10px'
                }}
            >
                <UserTab
                    colors={props.colors}
                    initals="JB"
                    tokenSafeAPIRequest={props.tokenSafeAPIRequest}
                />
            </div>

            <div
                style={{
                    flex: '0 0 150px',
                    borderBottom: '1px solid ' + props.colors.border,
                    marginLeft: '20px'
                }}
            >
                <span
                    style={{
                        color: props.colors.font,
                        fontSize: '40px',
                        fontWeight: '500'
                    }}
                >
                    {props.title}
                </span>
            </div>

            <div
                className='noSelect'
                style={{
                    // Critical for scrollable children inside flex containers.
                    flex: '1 1 auto',
                    minHeight: 0,

                    overflowY: 'auto',
                    overflowX: 'hidden',

                    // Safari / iOS scrolling improvements.
                    WebkitOverflowScrolling: 'touch',
                    touchAction: 'pan-y',

                    // Prevent scroll chaining into the page where supported.
                    overscrollBehaviorY: 'contain'
                }}
            >
                {props.buttonList.length > 0
                    ? renderButton(props.buttonList[0], 0, true)
                    : null
                }

                {props.buttonList.map((button, index) => {
                    if (index === 0) return null

                    return renderButton(button, index, false)
                })}
            </div>
        </div>
    )
}

export default Main